import { SvgPropType } from './types/svgPropType';

/** Twitch “Glitch” mark — recognizable chat bubble + vertical bars (Bootstrap Icons–style paths, scaled) */
const TwitchIcon = ({ width, height }: SvgPropType) => (
    <svg width={width || '32'} height={height || 32} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.857 0 1 2.857v10.286h3.429V16l2.857-2.857H13l3-3V0H3.857zm9.714 9.714-2.571 2.571H9l-2 2v-2H4.429V1.143h9.142v8.571z"
            fill="black"
        />
        <path
            d="M9.714 4.143H8v4.286h1.714V4.143zM13 4.143h-1.714v4.286H13V4.143z"
            fill="black"
        />
    </svg>
);

export default TwitchIcon;
